import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { ICreateDocByTemplateDialogExecutorProps } from './ICreateDocByTemplateDialogExecutorProps';
import { CreateDocByTemplateDialogExecutorModal } from './CreateDocByTemplateDialogExecutorModal';

export const CreateDocByTemplateDialogExecutor = createDocModalExecutor<ICreateDocByTemplateDialogExecutorProps>({
    modal: CreateDocByTemplateDialogExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
